import React from "react";
import { connect } from "formik";
import { compose } from "redux";
import styled from "styled-components";
import { Grid } from "@material-ui/core";
import { DatePicker, PercentInput, AutoCompleteInput, DecimalInput, IntegerInput } from "components/Global/FormikMaterial";
import { FormikInputSwitch } from "@loanbossinc/component-library";

import { interestRateRounding } from "../../Constants/DropDownLists";

const StyledDatePicker = styled(DatePicker)`
  & {
      width:100%;
      margin-top:-2px !important;
    }
`;
const StyledIntegerInput = styled(IntegerInput)`
  & {width:100%;}
`;
const StyledDecimalInput = styled(DecimalInput)`
  & {width:100%;}
`;
const StyledPercentInput = styled(PercentInput)`
  & {width:100%;}
`;
const StyledAutoCompleteInput = styled(AutoCompleteInput)`
  & {width:100%;}
`;
const StyledInputSwitchGrid = styled(Grid)`
  & {
    label {
        margin-left:0px;
        margin-top: 16px;
    }    
  }
`;
const StyledLabel = styled.div`{
  //styleName: Work Sans / 16 Medium;
  font-family: Work Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
 }`;

const SpreadMaintenanceFields = ({ formik }) => {
  const handleToggleSwitch = () => {
    if (formik.values.shouldUsePV) {
      formik.setFieldValue("replacementRateSpread", "0.0");
      formik.setFieldValue("lookbackDays", "");
      formik.setFieldValue("interestRateRounding", "");
    }
  };

  return (
    <>
      <Grid item xs={6}>
        <StyledDatePicker
          label={<StyledLabel>{"Prepayment Date"}</StyledLabel>}
          fieldName="prepaymentDate"
        />
      </Grid>
      <Grid item xs={6}>
        <StyledIntegerInput
          label={<StyledLabel>{"Open Periods"}</StyledLabel>}
          fieldName="openPeriods"
        />
      </Grid>
      <Grid item xs={6}>
        <StyledPercentInput
          label={<StyledLabel>{"Minimum Penalty (%)"}</StyledLabel>}
          decimalScale={3}
          fieldName="minimumPenalty"
          allowNegative={false}
        />
      </Grid>
      <StyledInputSwitchGrid item xs={12}>
        <FormikInputSwitch
          name="shouldUsePV"
          onClick={handleToggleSwitch}
          label={"Use present value in this calculation"}
        />
      </StyledInputSwitchGrid>
      {formik.values.shouldUsePV && (
        <>
          <Grid item xs={6}>
            <StyledDecimalInput
              label={<StyledLabel>{"Replacement Rate Spread (bps)"}</StyledLabel>}
              decimalScale={2}
              fieldName="replacementRateSpread"
              allowNegative
            />
          </Grid>
          <Grid item xs={6}>
            <StyledIntegerInput
              label={<StyledLabel>{"Replacement Rate Lookback"}</StyledLabel>}
              fieldName="lookbackDays"
            />
          </Grid>
          <Grid item xs={6}>
            <StyledAutoCompleteInput
              label={<StyledLabel>{"Replacement Rate Rounding"}</StyledLabel>}
              fieldName="interestRateRounding"
              selectValue="value"
              options={interestRateRounding}
            />
          </Grid>
        </>
      )}
    </>
  );
};
export default compose(
  connect
)(SpreadMaintenanceFields);
